module.exports = __webpack_public_path__ + "img/ESG_korkep_2024.c67ebf70.jpg";